import axiosInstance from "./AxiosInstance";

const TaskService = {
  getTasks: async (page = 1, limit = 10, search = "", categories = "", archived = false) => {
    try {
      const params = {
        page,
        limit,
        search,
        categories,
      };
      
      if (archived) {
        params.archived = true;
      }
      
      const response = await axiosInstance.get("/v1/tasks", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTaskById(id) {
    return axiosInstance.get(`/v1/tasks/${id}`);
  },

  createTask: async (taskData) => {
    try {
      const response = await axiosInstance.post("/v1/tasks", taskData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateTask(id, taskData) {
    return axiosInstance.put(`/v1/tasks/${id}`, taskData);
  },

  deleteTask: async (taskId) => {
    try {
      const response = await axiosInstance.delete(`/v1/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  archiveTask: async (taskId, isArchived = true) => {
    try {
      const response = await axiosInstance.patch(`/v1/tasks/${taskId}/archive`, {
        isArchived
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default TaskService;
